<button
  *ngIf="podeDeclinar()"
  (click)="abrilModalAditivo(modalAditivo)"
  class="btn btn-round btn-min-width box-shadow-4 btn-min-width mr-1 mb-1 pointer"
  style="background: #da4453 !important; color: #fff">
  <i class="fa fa-ban"></i>
  Declinar
</button>

<ng-template #modalAditivo>
  <app-modal-simples [title]="'Declinar Proposta'" (cancel)="fecharModal()"></app-modal-simples>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="form-section font-weight-bold">Motivo Declinio</label>
            <div class="rounded">
              <textarea
                [(ngModel)]="motivoDeclinio"
                maxlength="250"
                rows="5"
                class="form-control border-radius box-shadow-4"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-end mt-1 mr-1">
    <button
      type="button"
      class="btn btn-round btn-geia-info btn-outline-success cursor-pointer btn-min-width box-shadow-4 mr-1 mb-1"
      (click)="declinarProposta()">
      <i class="ft-times"></i>
      Concluir Declinio
    </button>
  </div>
</ng-template>
